// Tarayıcı depolama yardımcıları: JSON okuma/yazma hataları yutulmaz, konsola uyarı düşer
export const readJson = (key, fallback = null, store = sessionStorage) => {
  try {
    const raw = store.getItem(key);
    return raw == null ? fallback : JSON.parse(raw);
  } catch (e) {
    console.warn(`[storage] ${key} okunamadı`, e);
    return fallback;
  }
};

export const writeJson = (key, value, store = sessionStorage) => {
  try { store.setItem(key, JSON.stringify(value)); }
  catch (e) { console.warn(`[storage] ${key} yazılamadı`, e); }
};

export const removeKey = (key, store = sessionStorage) => {
  try { store.removeItem(key); }
  catch (e) { console.warn(`[storage] ${key} silinemedi`, e); }
};

// Oturum kapanınca taslak/filtre gibi oturuma bağlı tüm veriler temizlenir
export const clearSessionData = () => {
  try { sessionStorage.clear(); }
  catch (e) { console.warn("[storage] sessionStorage temizlenemedi", e); }
};
